import { Pixel } from "./pixel";

export class CanvasImage {
  private image: HTMLImageElement;
  private canvas: HTMLCanvasElement;
  private context: any;
  private isLoaded: boolean = false;
  private loadedFunction!: () => void;
  private height!: number;
  private width!: number;

  constructor(src: string) {
    this.canvas = document.createElement("canvas");
    this.context = this.canvas.getContext && this.canvas.getContext("2d");
    this.image = document.createElement("img") as HTMLImageElement;
    this.image.setAttribute("crossorigin", "anonymous");
    this.image.src = src;
    this.image.onload = this.imageLoaded;
  }

  imageLoaded = () => {
    this.height =
      this.image.naturalHeight || this.image.offsetHeight || this.image.height;
    this.width =
      this.image.naturalWidth || this.image.offsetWidth || this.image.width;
    this.canvas.height = this.height;
    this.canvas.width = this.width;
    this.context.drawImage(this.image, 0, 0);
    this.isLoaded = true;
    if (this.loadedFunction) {
      this.loadedFunction();
    }
  };

  getBase64() {
    return this.canvas.toDataURL();
  }

  loaded(func: () => void) {
    this.loadedFunction = func;
    if (this.isLoaded) {
      this.loadedFunction();
    }
  }

  hasColorsSimilarTo(compare: Pixel, area: any): number {
    const data = this.getImageData(area);
    if (!data) {
      return 0;
    }
    const length: number = data.data.length;
    const blockSize: number = 1; //  only visit every 5 pixels
    let count: number = 0;
    //  const pixel: Pixel;
    let i: number = -4;
    const compareDarkness = compare.getDarkness();
    // if (compareDarkness == 0) {
    //     compareDarkness = .001;
    // }
    // console.log('compareTo: '+compareDarkness);
    let similarPixels = 0;
    i += blockSize * 4;
    while (i < length) {
      i += blockSize * 4;
      if (data.data[i + 3] !== 0) {
        ++count;
        const pixel: Pixel = new Pixel(
          data.data[i],
          data.data[i + 1],
          data.data[i + 2],
          data.data[i + 3]
        );
        const darkness = pixel.getDarkness();
        // if (darkness == 0) {
        //     darkness = .001;
        // }
        // if (count < 5) {
        //     // console.log(darkness);
        // }
        if (
          darkness < compareDarkness ||
          Math.abs((darkness - compareDarkness) / darkness) < 0.4
        ) {
          similarPixels++;
        }
      }
    }
    // console.log('similar pixels: '+similarPixels + ' of: '+count);
    const percentSimilar: number = similarPixels / count;
    // console.log('similar Percent: '+percentSimilar);
    return percentSimilar;
    // return percentSimilar > .1;
  }

  isDark() {
    const data = this.getImageData();
    if (!data) {
      return false;
    }
    const length: number = data.data.length;
    const blockSize: number = 5; //  only visit every 5 pixels
    let count: number = 0;
    // const pixel: Pixel;
    let i: number = -4;
    let darkPixelCount: number = 0;
    let lightPixelCount: number = 0;
    let highDarkTotal: number = 0;
    let lowDarkTotal: number = 0;
    i += blockSize * 4;
    while (i < length) {
      i += blockSize * 4;
      ++count;
      if (data.data[i + 3] !== 0) {
        const pixel: Pixel = new Pixel(
          data.data[i],
          data.data[i + 1],
          data.data[i + 2],
          data.data[i + 3]
        );
        const darkness = pixel.getDarkness();
        if (darkness > 0.5) {
          highDarkTotal += darkness;
          darkPixelCount++;
        } else {
          lowDarkTotal += darkness;
          lightPixelCount++;
        }
      }
    }
    let highContrast = false;
    // console.log('dark: ' + darkPixelCount + ' vs light: ' + lightPixelCount);
    if (darkPixelCount !== 0 && lightPixelCount !== 0) {
      const highDarkAvg = highDarkTotal / darkPixelCount;
      const lowDarkAvg = lowDarkTotal / lightPixelCount;
      // console.log('Contrast: ' + (highDarkAvg - lowDarkAvg));
      highContrast = highDarkAvg - lowDarkAvg > 0.5;
      // console.log("HIGH CONTRAST: " + highContrast);
    }
    if (highContrast) {
      // return false;
    }
    return darkPixelCount > lightPixelCount;
  }

  private getImageData(boxPercent?: any): any {
    if (typeof boxPercent === "undefined") {
      boxPercent = { x: 0, y: 0, w: 1, h: 1 };
    }
    let data: any = null;
    try {
      data = this.context.getImageData(
        this.width * boxPercent.x,
        this.height * boxPercent.y,
        this.width * boxPercent.w,
        this.height * boxPercent.h
      );
      // data = this.context.getImageData(0, 0, this.width, this.height);
    } catch (e) {
      // console.log("CROSS ORIGIN");
    }
    return data;
  }
}
